// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallStatusChart_title__A3FE6 {
  font-size: 1.125rem;
}

@media screen and (min-width: 75em) {
  .CallStatusChart_title__A3FE6 {
    font-size: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/reporting/components/CallStatusChart.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE;IACE,iBAAA;EACF;AACF","sourcesContent":[".title {\n  font-size: 1.125rem;\n}\n\n@media screen and (min-width: 75em) {\n  .title {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `CallStatusChart_title__A3FE6`
};
export default ___CSS_LOADER_EXPORT___;
